<template>
  <ion-page>
    <main-header></main-header>
    <ion-content padding>
      <div class="ion-text-center">
        <img src="./check.svg" alt="check" />
      </div>
      <div class="ion-text-center ion-margin-bottom ion-padding-bottom">
        Relax, sit back and watch the action! Your Stay Seated order has been
        placed and is on its way.
      </div>
      <div class="ion-text-center ion-margin-top">
        <ion-button @click="handleTrackMyOrder()" expand="block">
          Track My Order
        </ion-button>
        <hr />
        <ion-button color="light" @click="handlePlaceAnother()">
          Place Another Order
        </ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  title: "Order Submitted",

  /**
   * We are cleaning up the current order when they visit here, that way they shouldn't be able
   * to navigate back - and also it clears out because they're done with that format of order
   */
  created() {
    this.clearOrder();
  },

  methods: {
    ...mapMutations("order", ["clearOrder"]),

    handlePlaceAnother() {
      this.$router.push({ name: "App: Location Menu" }).catch(e => e);
    },

    handleTrackMyOrder() {
      this.$router.push({ name: "App: Order History" }).catch(e => e);
    }
  }
};
</script>

<style scoped>
hr {
  margin: 3vh auto;
  width: 40%;
  background: rgba(0, 0, 0, 0.13);
}
img {
  height: 10vh;
  margin: 3vh auto;
}
</style>
